<template>
   <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 20 15" fill="none" stroke="#56C0EE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
</template>

<script>
export default {
  name: 'IconChevronDownSmall'
}
</script>
